import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHeading } from "../../../redux/slice/headerSlice";
import { Link } from "react-router-dom";

const ERPSyncActive = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeading("ERP Sync Active"));
  }, []);

  return (
    <main>
      <div className="route-invoice bluebg">
        <h4 className="route-invoice-top">
          <img src="/images/erp_sync.svg" alt="ERP Sync" />
          Enable ERP Sync
        </h4>
        <div className="route-sync active">
          <i class="fa-regular fa-circle-check"></i> Sync is active and running
        </div>
        <p>
          You are earning <strong>1,000 points</strong> daily!
        </p>
      </div>

      <div className="route-box">
        <span className="route-box-icon greenbg">
          <img src="/images/congratulations.png" alt="" />
        </span>
        <h4>Congratulations!</h4>
        <p>Your ERP sync is active and you're earning points daily</p>
      </div>

      <div className="route-details bluebg">
        <h4>Sync Detail</h4>
        <ul>
          <li>
            Connected ERP: <span>Tally</span>
          </li>
          <li>
            Points earned today: <span>1,000</span>
          </li>
        </ul>
        
      </div>

      <div className="route-synchistory">
        <h4>Sync History</h4>
        <div className="route-synchistory-details">
          <div className="route-synchistory-details-box">
            <div className="route-synchistory-details-box-left">
              {/* <span>
                <img src="/images/successful.png" alt="" />
              </span> */}
            13-06-2025 | 10:30 AM
            </div>
            <div className="route-synchistory-details-box-right earned">
              +1000 points
            </div>
          </div>
          <div className="route-synchistory-details-box">
            <div className="route-synchistory-details-box-left">
              {/* <span>
                <img src="/images/successful.png" alt="" />
              </span> */}
              13-06-2025 | 10:30 AM
            </div>
            <div className="route-synchistory-details-box-right earned">
              +1200 points
            </div>
          </div>
          <div className="route-synchistory-details-box">
            <div className="route-synchistory-details-box-left">
              {/* <span>
                <img src="/images/successful.png" alt="" />
              </span> */}
              13-06-2025 | 10:30 AM
            </div>
            <div className="route-synchistory-details-box-right earned">
              +900 points
            </div>
          </div>
        </div>
      </div>

      <div className="route-pushBox bluebg mb-15">
        <div className="route-pushBox-left">
          <img src="/images/important.png" alt="" />
        </div>
        <div className="route-pushBox-right">
          <h4>Important Note</h4>
          <p>
            Points earning will stop if the ERP sync is disabled or interrupted.
            Keep you ERP synced continuously to earn points every day.
          </p>
        </div>
      </div>
    </main>
  );
};

export default ERPSyncActive;
